import { ApiResponse } from "@/interfaces/api-response";
import { Font, UploadManyFonts } from "@/interfaces/font.interface";
import apiClient from "@/utils/axios";

const SERVICE_ENDPOINT = "fonts";

const getMany = async (params: {
  sort?: string;
  page?: number;
  size?: number;
  search?: string;
  categoryId?: string;
}) => {
  const response = await apiClient.get<ApiResponse<Font[]>>(
    `/${SERVICE_ENDPOINT}`,
    {
      params,
    },
  );
  return response.data;
};

const getOneById = async (id: string, params?: object) => {
  const response = await apiClient.get<ApiResponse<Font>>(
    `/${SERVICE_ENDPOINT}/${id}`,
    { params },
  );
  return response.data;
};

const updateOneById = async (
  id: string,
  data: Partial<Font>,
  params?: object,
) => {
  const response = await apiClient.put<ApiResponse<Font>>(
    `/${SERVICE_ENDPOINT}/${id}`,
    data,
    { params },
  );
  return response.data;
};

const deleteOneById = async (id: string) => {
  const response = await apiClient.delete<ApiResponse<Font>>(
    `/${SERVICE_ENDPOINT}/${id}`,
  );
  return response.data;
};

const uploadMany = async (payload: UploadManyFonts) => {
  const response = await apiClient.post<ApiResponse<Font>>(
    `/${SERVICE_ENDPOINT}/upload-many`,
    payload,
  );
  return response.data;
};

const fontApi = {
  getMany,
  getOneById,
  updateOneById,
  deleteOneById,
  uploadMany,
};

export default fontApi;
